import { render, staticRenderFns } from "./lawsTable.vue?vue&type=template&id=4b08b236&"
import script from "./lawsTable.vue?vue&type=script&lang=js&"
export * from "./lawsTable.vue?vue&type=script&lang=js&"
import style0 from "./lawsTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports